<template>
  <!-- Компонент вопрос -->
  <QuizQuestion :question="question" />
  <!-- Компонент вопрос -->

  <div class="quiz-options quiz__true-false">
    <button
      class="btn"
      v-for="(option, optionIndex) in options"
      :key="optionIndex"
      @click="selectOption(optionIndex)"
      :class="getButtonClass(optionIndex)"
    >
      {{ option }}
    </button>
  </div>
</template>

<script>
import QuizQuestion from "@/components/QuizQuestion/QuizQuestion.vue";

export default {
  name: 'TrueFalse',
  components: {
    QuizQuestion
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedAnswer: {
      type: Number,
      default: null
    },
    showResults: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answer-selected', 'auto-check-answer'],
  data() {
    return {
      options: ['Миф', 'Правда']
    }
  },
  computed: {
    correctOptionIndex() {
      // Если correct_answer true - правильная кнопка "Правда" (индекс 1)
      // Если correct_answer false - правильная кнопка "Миф" (индекс 0)
      return this.question.correct_answer ? 1 : 0;
    },
    isAnswerCorrect() {
      return this.selectedAnswer === this.correctOptionIndex;
    }
  },
  methods: {
    selectOption(optionIndex) {
      if (!this.showResults) {
        this.$emit('auto-check-answer', this.question.id, optionIndex);
      }
    },
    getButtonClass(optionIndex) {
      const classes = ['btn'];

      // Базовый зеленый цвет для кнопки "Правда"
      if (optionIndex === 1) {
        classes.push('btn--green');
      }

      return classes;
    }
  }
};
</script>

<style scoped lang="scss">
.quiz-options.quiz__true-false {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  margin-bottom: 0;
  margin-top: auto;

  & .btn {
    flex-grow: 1;
    text-transform: none;
  }
}
</style>
